import React from "react";
import { helpFunc } from "../../helpers/helpFunction";
import { PatientInfoTableLogic } from "./PatientInfoTableLogic";

export const PatientInfoTable = ({ row, careType }) => {
  const { patient, state, care } = PatientInfoTableLogic(row);
  return (
    <div className="patient-info-table">
      {state.loading ? (
        <h1>Loading...</h1>
      ) : (
        <>
          {state.error && <h1>Chyba načítání pacienta</h1>}
          <div className="header patient-info-cell">
            <strong>Příjmení a jméno pacienta</strong>
          </div>
          <div className="header patient-info-cell">
            <strong>{patient?.name}</strong>
          </div>
          <div className="patient-info-cell strong">Datum narození</div>
          <div className="patient-info-cell">{patient?.birth_date}</div>
          <div className="patient-info-cell strong">Diagnóza</div>
          <div className="patient-info-cell">
            {patient?.current_care?.main_diagnosis?.name || "Žádná diagnóza"}
          </div>
          <div className="patient-info-cell strong">Hmotnost</div>
          <div className="patient-info-cell">
            {patient?.weight || "Žádné informace"} kg
          </div>
          <div className="patient-info-cell strong">Výška</div>
          <div className="patient-info-cell">
            {patient?.height || "Žádné informace"} cm
          </div>
          {careType !== "hospitalization" && (
            <>
              <div className="patient-info-cell strong">Poznámka</div>
              <div className="patient-info-cell">
                {patient?.note || "Žádné poznámky"}
              </div>
            </>
          )}
          <div className="patient-info-cell strong">BMI</div>
          <div className="patient-info-cell">
            {patient?.bmi || "Žádné informace"}
          </div>
          <div className="patient-info-cell strong">Rodné číslo</div>
          <div className="patient-info-cell">{patient.birth_number}</div>
          <div className="patient-info-cell strong">ID pacienta</div>
          <div className="patient-info-cell">{patient?.external_id || ""}</div>
          {careType === "hospitalization" ? (
            <>
              <div className="patient-info-cell strong">
                Počet dnů hospitalizace k dnešnímu dni
              </div>
              <div className="patient-info-cell">
                {patient?.current_care_days || "Žádné informace"}
              </div>

              <div className="patient-info-cell strong">
                Datum posledního napsaného dekurzu
              </div>
              <div className="patient-info-cell">
                {patient?.last_dekurz || "Žádné informace"}
              </div>
            </>
          ) : (
            <>
              <div className="patient-info-cell strong">
                Datum návštěvy ambulance
              </div>
              <div className="patient-info-cell">
                {patient?.first_visit || "Žádné informace"}
              </div>
            </>
          )}
          <div className="patient-info-cell strong">
            {careType === "hospitalization"
              ? "Ošetřující lékař"
              : "Jméno lékaře (žadatele)"}
          </div>
          <div className="patient-info-cell">
            {careType === "hospitalization"
              ? `${patient?.f_title || ""} ${
                  patient?.current_care?.last_dekurz?.doctor?.name ||
                  "Žádné informace"
                } ${patient?.l_title || ""}`
              : patient.current_care.ambulant_doctor
              ? `${patient.current_care.ambulant_doctor.f_title || ""} ${
                  patient.current_care.ambulant_doctor.name
                } ${patient.current_care.ambulant_doctor.l_title || ""}`
              : "Žádné informace"}
          </div>
          <div className="patient-info-cell strong">Klinika</div>
          <div className="patient-info-cell">
            {patient?.current_care?.clinic?.description || "Žádné informace"}
          </div>
          <div className="patient-info-cell strong">Oddělení</div>
          <div className="patient-info-cell">
            {careType === "hospitalization"
              ? patient?.current_care_last_dekurz_department_description ||
                "Žádné informace"
              : patient.department}
          </div>
          <button
            className="button patient-info-table-button"
            type="button"
            {...row.getToggleRowExpandedProps()}
          >
            Zpět
          </button>
          <div>{!care.loading && care.list}</div>
        </>
      )}
    </div>
  );
};
